import { render, staticRenderFns } from "./RatingsFilter.vue?vue&type=template&id=5c108b86&"
import script from "./RatingsFilter.vue?vue&type=script&lang=js&"
export * from "./RatingsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports